import { jsx as _jsx } from "react/jsx-runtime";
import { Modal, notification, Spin } from '@zenlayer/zen-design';
import { useRequest } from 'ahooks';
import { EMethods, Verify } from './verify';
import { getAuthenticationMethods, putResendCaptcha, putVerify, } from '../../api/authentication';
import t from '@zenlayer/zen-intl18';
const Content = ({ onError, onSuccess, }) => {
    const ResendCaptchaRequest = useRequest(putResendCaptcha, {
        manual: true,
        onSuccess: (res) => {
            if (!res.success) {
                notification.error({ description: res.msg });
            }
        },
    });
    const MethodsRequest = useRequest(getAuthenticationMethods, {
        onSuccess: (res) => {
            if (res.success) {
                !res.data?.types?.includes(EMethods.TOTP) && ResendCaptchaRequest.run();
            }
            else {
                notification.error({ description: res.msg });
                onError();
            }
        },
    });
    const methods = MethodsRequest.data?.data?.types || [];
    const username = MethodsRequest.data?.data?.username;
    const VerifyRequest = useRequest(putVerify, {
        manual: true,
        onSuccess: (res) => {
            if (res.success) {
                onSuccess();
            }
            else {
                notification.error({ description: res.msg });
            }
        },
    });
    return (_jsx(Spin, { spinning: MethodsRequest.loading, children: _jsx(Verify, { methods: methods, email: username, onResendCaptcha: ResendCaptchaRequest.run, onVerify: VerifyRequest.run, verifyLoading: VerifyRequest.loading }) }));
};
const useOpenAuthenticationModal = () => {
    const [modal] = Modal.useModal();
    const open = async () => {
        return new Promise(async (resolve, reject) => {
            modal.open({
                title: t('zePpacnsxTMN'),
                width: 444,
                closable: true,
                content: (_jsx(Content, { onError: () => {
                        modal.close();
                        resolve(false);
                    }, onSuccess: async () => {
                        modal.close();
                        resolve(true);
                    } })),
                onCancel: () => {
                    resolve(false);
                },
                okButtonText: null,
                cancelButtonText: null,
            });
        });
    };
    return { open };
};
export const useAuthenticationRequest = (service, ...opts) => {
    const { open } = useOpenAuthenticationModal();
    const result = useRequest(async (...arg) => {
        const res = await service(...arg);
        if (res.code === 'NEED_SECOND_AUTH') {
            const success = await open();
            return success
                ? await service(...arg)
                : {
                    success: false,
                    msg: t('uVM3aUEjSuhU'),
                    data: null,
                };
        }
        return res;
    }, ...opts);
    return result;
};
